<template>
  <div class="bg">
    <div class="container">
      <div class="title">
        <!-- <span
        style="
          margin-left: 10px;
          color: #1f1f1f;
          font-size: 20px;
          font-weight: 400;
        "
        >培训搜索</span
      > -->
        <div class="car-title">全部培训</div>
      </div>
      <div class="select-group">
        <el-select
          v-model="value"
          @change="search"
          placeholder="请选择培训地区"
          clearable
        >
          <el-option
            v-for="(item, index) in areaList"
            :key="index"
            :label="item.areaName"
            :value="item.areaId"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="target"
          @change="targetChange"
          placeholder="培训对象"
          clearable
        >
          <el-option
            v-for="(item, index) in targetList"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="year"
          @change="yearChange"
          placeholder="培训年度"
          clearable
        >
          <el-option
            v-for="(item, index) in yearList"
            :key="index"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="status"
          @change="stathsChange"
          placeholder="状态"
          clearable
        >
          <el-option
            v-for="item in statuList"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          >
          </el-option>
        </el-select>
        <!-- <el-button @click="search">搜索</el-button> -->
      </div>
      <div class="content" v-if="show">
        <div
          :class="`item item${signUpStatus(item)}`"
          v-for="(item, index) in classList"
          :key="index"
          @click="
            $router.push({ path: '/class', query: { id: item.classConfigId } })
          "
        >
          <img
            :src="item.classLogo"
            width="200px"
            height="140px"
            style="border-radius: 6px"
            alt=""
          />
          <div class="item-right">
            <p class="title">{{ item.className }}</p>
            <div class="desc">
              <span>{{ item.classDesc }}</span>
            </div>
            <div class="data">
              <img src="../../assets/image/bmsj.png" alt="" />
              <p>
                报名时间：{{ timestampToTime(item.applyStartTime) }}-{{
                  timestampToTime(item.applyEndTime)
                }}
              </p>
            </div>
            <div class="data">
              <img src="../../assets/image/xxsj.png" alt="" />
              <p>
                学习时间：{{ timestampToTime(item.studyStartTime) }}-{{
                  timestampToTime(item.studyEndTime)
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="page">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <div v-else></div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  name: "index",
  data() {
    return {
      areaList: [],
      statusList: [
        {
          label: "无效",
          value: "0",
        },
        {
          label: "有效",
          value: "1",
        },
      ],
      show: false,
      classList: [],
      value: "",
      value1: "",
      value2: "",
      total: 0,
      target: "",
      targetList: [
        "采购人（预算单位）",
        "供应商",
        "采购代理机构",
        "评审专家",
        "监管部门",
        "政府采购从业人员",
      ],
      year: "",
      yearList: [2021, 2022, 2023],
      status: "",
      statuList:[{
        key:1,
        label: '未开始',  
      },
      {
        key:2,
        label: '报名中',  
      },
      {
        key:3,
        label: '已结束',  
      },
    ]
    };
  },
  mounted() {
    this.setYearList();
    this.getAreaList();
    this.value = this.$route.query.key ? parseInt(this.$route.query.key) : "";
    // console.log(this.value)
    if (this.value) {
      this.search();
    } else {
      this.getClassList();
    }
  },
  methods: {
    setYearList() {
      const date = new Date();
      const year = date.getFullYear();
      this.yearList = [year - 2, year - 1, year];
    },
    signUpStatus(item) {
      //1未开始 2已开始 3已结束
      let status = 2;
      let now = new Date().getTime();
      if (now > item.applyEndTime) {
        // 报名已结束
        status = 3;
      } else if (now < item.applyStartTime) {
        // 报名未开始
        status = 1;
      }
      return status;
    },

    targetChange() {
      api.targetForTraining(this.target).then((res) => {
        if (res.data.list.length === 0) {
          this.$message.warning("抱歉，没有找到相关培训。");
          this.show = false;
        } else {
          this.classList = res.data.list;
          this.show = true;
        }
      });
    },
    yearChange() {
      api.yearForTraining(this.year).then((res) => {
        if (res.data.list.length === 0) {
          this.$message.warning("抱歉，没有找到相关培训。");
          this.show = false;
        } else {
          this.classList = res.data.list;
          this.show = true;
        }
      });
    },

    // 状态change事件
    stathsChange(){
      let pageNo = 1;
      api.class(1, pageNo, 999).then((res) => {
        if (res.data.list.length === 0) {
          this.$message.warning("抱歉，没有找到相关培训。");
          this.show = false;
        } else {
          //1未开始 2已开始 3已结束
          const newArr =  res.data.list.map(item => {
            item.status =this.signUpStatus(item)
            return item
          });
          const dasa =this.status? newArr.filter(item => {
            return item.status === this.status
          }):newArr
          if (dasa.length === 0) {
            this.show = false;
            return this.$message.warning("抱歉，没有找到相关培训。");
          }
          this.classList = dasa;
          this.total = 10
          this.show = true;
        }
      });


      console.log('我要改变了')
    },

    search() {
      if (!this.value) {
        this.getClassList();
        return false;
      }
      api.classForArea(this.value).then((res) => {
        if (res.data.list.length === 0) {
          this.$message.warning("抱歉，没有找到相关培训。");
          this.show = false;
        } else {
          this.classList = res.data.list;
          this.show = true;
        }
      });
    },
    search2() {
      api.classForTime(this.value1).then((res) => {
        if (res.data.list.length === 0) {
          this.$message.warning("抱歉，没有找到相关培训。");
          this.show = false;
        } else {
          this.classList = res.data.list;
          this.show = true;
        }
      });
    },
    search3() {
      api.class(1, 1, 10).then((res) => {
        if (res.data.list.length === 0) {
          this.$message.warning("抱歉，没有找到相关培训。");
          this.show = false;
        } else {
          this.classList = res.data.list;
          this.show = true;
        }
      });
    },
    getAreaList() {
      api.area().then((res) => {
        this.areaList = res.data.list;
      });
    },
    getClassList(page) {
      let pageNo = page || 1;
      api.class(1, pageNo, 10).then((res) => {
        this.show = true;
        this.classList = res.data.list;
        this.total = res.data.total;
      });
    },
    handleCurrentChange(val) {
      console.log(val);
      this.getClassList(val);
    },
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "年";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "月";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日";
      return Y + M + D;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  min-height: 500px;
  background: white;
  margin: 20px auto;
  padding: 20px;
  .title {
    .car-title {
      position: relative;
      text-align: left;
      padding-left: 8px;
      height: 22px;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 16px;
      color: #264f99;
      line-height: 22px;
      text-align: justify;
      font-style: normal;
    }
    .car-title::before {
      content: "";
      width: 4px;
      height: 12px;
      background: #264f99;
      display: block;
      position: absolute;
      top: 6px;
      left: 0px;
    }
  }

  .select-group {
    margin-top: 16px;
    .el-select {
      width: 240px;
      margin-right: 20px;
    }
    .el-date-editor {
      width: 370px;
    }
    ::v-deep .el-button {
      width: 80px;
      height: 40px;
      background: #264f99;
      border-radius: 6px;
      color: #ffffff;
      font-size: 16px;
    }
  }

  .content {
    margin-top: 20px;
    display: flex;
    flex-direction: column;

    .item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      position: relative;
      &::after {
        position: absolute;
        top: 5px;
        right: 25px;
        content: "";
        width: 70px;
        height: 70px;
        background: url("../../assets/image/sign-up-icon1.png") no-repeat center
          center / 70px 70px;
      }
      &.item2 {
        &::after {
          background: url("../../assets/image/sign-up-icon2.png") no-repeat
            center center / 70px 70px;
        }
      }
      &.item3 {
        &::after {
          background: url("../../assets/image/sign-up-icon3.png") no-repeat
            center center / 70px 70px;
        }
      }

      .item-right {
        margin-left: 20px;
        height: 140px;
        display: flex;
        flex-direction: column;
        padding: 4px 0px;
        box-sizing: border-box;
        .desc {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 18px;
          text-align: justify;
          font-style: normal;
          flex: 1;
          overflow: hidden;
          span {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3; /* 这里指定最多显示3行 */
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .title {
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 400;
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          text-align: justify;
          font-style: normal;
          margin: 0px;
          margin-bottom: 8px;
        }
        .data {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            height: 14px;
          }
          p {
            margin: 0px;
            font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
            line-height: 20px;
            text-align: justify;
            font-style: normal;
            margin-left: 6px;
          }
        }
      }
    }
  }
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #264f99;
  color: #264f99;
  background: none;
}
.page {
  display: flex;
  justify-content: right;
  margin-top: 20px;
}
</style>
